import { useMutation } from '@tanstack/react-query'
import { FileService } from '../services/FileService'

export default function useMutationUploadCustomCss() {
	return useMutation({
		mutationFn: (cssContent: string) => FileService.uploadCustomCss(cssContent),
	})
}
